import { useContext } from 'react'
import { useDispatch } from 'react-redux'
import useQuery from '@cbgms/base/http/use-query'
import { VehicleProvider } from '@cbgms/api'
import { ShopCountry } from '@cbgms/base/shop-id'
import { LocaleContext } from '@cbgms/base/locale/LocaleContext'
import { loadBrands } from 'app/vehicles/state/actions'
import { useGetBrandsCacheKey } from './cacheKeys'

export const useGetBrands = (provider: VehicleProvider, country: ShopCountry) => {
  const dispatch = useDispatch()
  const { locale } = useContext(LocaleContext)

  return useQuery(
    useGetBrandsCacheKey(provider, country),
    async () => {
      const { Data } = await dispatch(loadBrands(locale, country, provider))
      return Data.map(brand => ({ key: brand.ManufacturerID, name: brand.ManufacturerName, value: brand.ManufacturerID }))
    },
    { staleTime: 2 * 60 * 1000 }
  )
}
